import { createContext } from 'react';

import type { AnalyticsAdapter } from './types';

interface AnalyticsContextValue {
  adapter: AnalyticsAdapter | null;
}

const AnalyticsContext = createContext<AnalyticsContextValue>({
  adapter: null,
});

export { AnalyticsContext };
export type { AnalyticsContextValue };
